import {ApiBuilder, LoginRequest} from "..";
import {Auth, Response} from "@core/model";

const login = (builder: ApiBuilder) =>
  builder.query<Auth, LoginRequest>({
    query: request => ({
      url: "/auth/login",
      method: "POST",
      body: request,
    }),
    transformResponse: (response: Response<Auth> | Auth) => {
      // Json server will not wrap login response
      if ((response as Response<Auth>).code === undefined) {
        return response as Auth;
      } else {
        return (response as Response<Auth>).data;
      }
    },
  });

const logout = (builder: ApiBuilder) =>
  builder.mutation<void, void>({
    query: () => ({
      url: "/auth/logout",
      method: "POST",
    }),
    transformResponse: (response: Response<void> | void) => {
      // Se la risposta è wrappata in Response, estrai i dati
      if (response && typeof response === "object" && "code" in response) {
        return (response as Response<void>).data;
      }
      return undefined;
    },
  });

const refreshToken = (builder: ApiBuilder) =>
  builder.query<Auth, void>({
    query: () => ({
      url: "auth/refresh-token",
      method: "POST",
    }),
    transformResponse: (response: Response<Auth>) => response.data,
  });

export {login, logout, refreshToken};
